import React, { FC } from 'react';
import {
  Approval as ApprovalType,
  CreateApprovalPayload,
  UpdateApprovalPayload,
} from 'api/approval';
import { TaskId } from 'api/models';
import { Approvals } from 'components/organisms/approvals';
import {
  useCreateTaskApprovalMutation,
  useDeleteTaskApprovalMutation,
  useUpdateTaskApprovalMutation,
} from 'queries/task-approvals';

interface Props {
  taskId: number;
  projectId: number;
  isPrivate: boolean;
  newData?: Partial<ApprovalType>;
  data: Array<ApprovalType>;
  onNewApprovalCancel: () => void;
  onNewApprovalSubmit: () => void;
  isDocumentTask: boolean;
}
export const TaskApprovals: FC<Props> = ({
  data: approvals = [],
  newData,
  taskId,
  projectId,
  isPrivate,
  onNewApprovalCancel,
  onNewApprovalSubmit,
  isDocumentTask,
}) => {
  // New approval actions.
  const { mutate: newApprovalMuatate, isLoading: isNewApprovalActionLoading } =
    useCreateTaskApprovalMutation(TaskId(projectId, taskId));
  const handleNewApprovalSubmit = (args: CreateApprovalPayload) => {
    newApprovalMuatate(args, {
      onSuccess: () => {
        if (onNewApprovalSubmit) {
          onNewApprovalSubmit();
        }
      },
    });
  };

  // Approval item change actions. (Approve/Reject)
  const task = TaskId(projectId, taskId);
  const { mutate, isLoading } = useUpdateTaskApprovalMutation(task);
  const handleApprovalChange = (
    payload: UpdateApprovalPayload,
    options: {
      onSuccess: () => void;
    },
  ) => {
    mutate(payload, options);
  };

  // Approval item change actions. Delete
  const { mutateAsync } = useDeleteTaskApprovalMutation(task);
  const handleApprovalDelete = (id: number) => {
    return mutateAsync(id);
  };

  return (
    <Approvals
      onNewApprovalCancel={onNewApprovalCancel}
      onNewApprovalSubmit={handleNewApprovalSubmit}
      newData={newData}
      isPrivate={isPrivate}
      data={approvals || []}
      projectId={projectId}
      isNewApprovalActionLoading={isNewApprovalActionLoading}
      isApprovalItemActionLoading={isLoading}
      onApprovalItemDelete={handleApprovalDelete}
      onApprovalItemActionSubmit={handleApprovalChange}
      isFromDocument={isDocumentTask}
    />
  );
};
